import {jsx} from 'panel';

import {SvgIconEl} from 'common/components/svg-icon';

import type {FunnelsFrequencyChart} from './index';

interface BodyContent {
  usersConverted?: string;
  percent?: string;
  usersDroppedOff?: string;
  subText?: string;
  count?: string;
}

const ConversionRateBody = ({content}: {content: BodyContent}) => (
  <div>
    <div sel='.popover-slot'>
      <div sel='.popover-icon.converted-icon'>
        <SvgIconEl attrs={{icon: `community`}} />
      </div>

      <div sel='.popover-slot.wrapper'>
        <div>{content.usersConverted}</div>
        <div>{content.percent}</div>
        <div>{content.usersDroppedOff}</div>
        <div>{content.subText}</div>
      </div>
    </div>
  </div>
);

const DefaultBody = ({content}: {content: BodyContent}) => (
  <div>
    <div sel='.popover-slot'>
      <div sel='.popover-icon.converted-icon'>
        <SvgIconEl attrs={{icon: `community`}} />
      </div>

      <div sel='.popover-slot.wrapper'>
        <div>{content.percent}</div>
        <div>{content.count}</div>
        <div>{content.subText}</div>
      </div>
    </div>
  </div>
);

export function popoverTemplate(this: FunnelsFrequencyChart) {
  const body: BodyContent[] = this.helpers.isConversionRate()
    ? this.helpers.popover.popoverBodyForConversionRate()
    : this.helpers.popover.popoverBody();

  return (
    <div sel='.popover-content-wrapper'>
      <div sel='.popover-slot'>
        <div sel='.popover-content-text-wrapper'>
          {body.map((content: BodyContent) => {
            return this.helpers.isConversionRate() ? (
              <ConversionRateBody content={content} />
            ) : (
              <DefaultBody content={content} />
            );
          })}
        </div>
      </div>
    </div>
  );
}
